<template>
<v-card class="my-3">
  <v-card-title class="title">
    Brief Summary
    <v-spacer />
    <v-dialog v-model="editing" max-width="500px" v-if="edit">
      <v-btn color="secondary darken-2" slot="activator">
        <v-icon left>mdi-pencil</v-icon> Edit
      </v-btn>
      <v-card>
        <v-card-title class="headline">
          Edit Brief Summary
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid" @submit.prevent="submit">
            <v-text-field v-model="blurb" counter="256" label="Brief Summary"
                          required :rules="rules.blurb" :error-messages="errors.blurb || []"/>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn flat @click="cancel">
            Cancel
          </v-btn>
          <v-btn :color="valid ? 'success' : 'error'" :disabled="!valid" @click="submit">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card-title>
  <v-card-text v-if="organization">
    <markdown :html="false" :source="organization.blurb" v-if="organization.blurb" class="markdown" />
    <v-alert v-else type="info" color="secondary darken-2" :value="true">
      Please provide a brief summary.
    </v-alert>
  </v-card-text>
</v-card>
</template>

<script>
import Markdown from 'vue-markdown'

export default {
  components: {
    Markdown
  },
  props: { organization: Object, edit: Boolean },
  data() {
    return {
      editing: false,
      valid: false,
      rules: {
        blurb: [v => !!v || 'must be specified', v => !v || v.length < 256 || 'must be shorter than 256 characters']
      },
      errors: {},
      modified: Object.assign({}, this.organization),
      blurb: this.organization.blurb || ''
    }
  },
  methods: {
    cancel() {
      this.blurb = this.organization.blurb
      this.editing = false
      this.errors = {}
    },
    submit() {
      if (this.valid) {
        this.modified.blurb = this.blurb
        this.update()
      }
    },
    update() {
      this.$store.dispatch('client/organization/update', this.modified).then(errors => {
        if (errors) {
          this.errors = errors
          this.$store.dispatch('snackbarError', 'There was a problem saving the brief summary')
        } else {
          this.$store.dispatch('snackbarSuccess', 'The brief summary was saved successfully')
          this.editing = false
        }
      })
    }
  }
}
</script>
